module.exports = __webpack_public_path__ + "img/gallery2.5e9e9958.webp";